// Lightweight pub/sub via window CustomEvent for live dashboard progress updates.
// No deps, no websockets — just fire-and-listen.

const EVENT_NAME = 'systemklar:progress-refresh';

export function emitProgressRefresh(reason = 'unknown') {
  try {
    window.dispatchEvent(new CustomEvent(EVENT_NAME, { detail: { reason, at: Date.now() } }));
  } catch (_) { /* no-op */ }
}

export function onProgressRefresh(handler) {
  const fn = (e) => handler(e?.detail || {});
  window.addEventListener(EVENT_NAME, fn);
  return () => window.removeEventListener(EVENT_NAME, fn);
}
